import { buildBackendUrl } from './backendUrl';
import { buildMedhugRequestHeaders } from '../utils/requestHeaders';

export const TAPNATIVE_IDENTITY_CAPTURE_PATH = '/tapnative-identity-capture';
export const TAPNATIVE_IDENTITY_CAPTURE_REPORT_PATH = '/tapnative-identity-capture-report';

async function parseJsonResponse(response) {
  try {
    return await response.json();
  } catch {
    return {};
  }
}

function buildError(data, fallback) {
  const error = new Error(data.message || data.error || fallback);
  error.code = data.error;
  error.data = data;
  return error;
}

async function postTapNativePayload(path, payload, fallbackError) {
  const response = await fetch(buildBackendUrl(path), {
    method: 'POST',
    headers: buildMedhugRequestHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }),
    credentials: 'include',
    body: JSON.stringify(payload || {}),
  });

  const data = await parseJsonResponse(response);
  if (!response.ok) {
    throw buildError(data, fallbackError);
  }
  return data;
}

export function captureTapNativeIdentity(payload) {
  return postTapNativePayload(
    TAPNATIVE_IDENTITY_CAPTURE_PATH,
    payload,
    'Unable to record TapNative identity.'
  );
}

export function reportTapNativeIdentityCaptureFailure(payload) {
  return postTapNativePayload(
    TAPNATIVE_IDENTITY_CAPTURE_REPORT_PATH,
    payload,
    'Unable to report TapNative identity capture failure.'
  );
}
